import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { familyCreatorPausePath, familyCreatorStagePath, newAccountPath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FamilyBioStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  bio: string | null;
}

type FormData = {
  bio: string;
};

const FamilyBioStep = ({ stage_index, stage_order, bio }: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => familyCreatorStagePath(stage),
      entryUrl: newAccountPath(),
      pauseUrl: familyCreatorPausePath(),
    },
    stageName: "bio",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { bio: bio ?? "" },
  });

  const bioField = bindField("bio", { validateOn: "blur" });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.families.creator.steps.bio.show.meta_title")}>
        <meta name="description" content={t("web.families.creator.steps.bio.show.meta_description")} />
      </Head>
      <FamilyBioStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={bioField.value}
        error={bioField.errorMessage}
        onChange={bioField.onChange}
        onBlur={bioField.onBlur}
      />
    </>
  );
};

export default FamilyBioStep;
